import React from "react";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import Loader from "@/components/site/Loader";
import CartDrawer from "@/components/site/CartDrawer";
import { CartProvider } from "@/context/CartContext";
import { SiteProvider } from "@/context/SiteContext";
import Home from "@/pages/Home";
import HomeOptionTwo from "@/pages/HomeOptionTwo";
import Shop from "@/pages/Shop";
import Product from "@/pages/Product";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import TheCraft from "@/pages/TheCraft";
import Journal from "@/pages/Journal";
import JournalArticle from "@/pages/JournalArticle";
import Motif from "@/pages/Motif";
import Checkout from "@/pages/Checkout";
import OrderConfirmation from "@/pages/OrderConfirmation";
import Simple from "@/pages/Simple";
import CollectionPreview from "@/pages/CollectionPreview";
import ShopPreview from "@/pages/ShopPreview";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminProductEdit from "@/pages/AdminProductEdit";
import MotifPreview from "@/pages/MotifPreview";
import HomePreview from "@/pages/HomePreview";
import HomeHeroPreview from "@/pages/HomeHeroPreview";
import HomeYesterdayPreview from "@/pages/HomeYesterdayPreview";
import HomeCinematicPreview from "@/pages/HomeCinematicPreview";
import HomeEditorialPreview from "@/pages/HomeEditorialPreview";
import NotFound from "@/pages/NotFound";
import { Toaster } from "sonner";
import "@/App.css";

const SiteChrome = ({ children }) => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Header />}
      <main className="min-h-screen">{children}</main>
      {!isAdmin && <Footer />}
      {!isAdmin && <CartDrawer />}
    </>
  );
};

function App() {
  const [firstMount, setFirstMount] = useState(true);
  useEffect(() => { const t = setTimeout(() => setFirstMount(false), 100); return () => clearTimeout(t); }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <SiteProvider>
          <CartProvider>
            {firstMount && <Loader />}
            <SiteChrome>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/home-option-1" element={<Home />} />
                <Route path="/home-option-2" element={<HomeOptionTwo />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/shop/" element={<Shop />} />
                <Route path="/shop/girls" element={<Shop categoryOverride="girls" />} />
                <Route path="/shop/boys" element={<Shop categoryOverride="boys" />} />
                <Route path="/shop/adults" element={<Shop categoryOverride="adults" />} />
                <Route path="/shop/twinning" element={<Shop twinning />} />
                <Route path="/shop/:cat" element={<Shop />} />
                <Route path="/product-category/:cat" element={<Shop />} />
                <Route path="/product-category/adults" element={<Shop categoryOverride="adults" />} />
                <Route path="/women" element={<Shop categoryOverride="adults" />} />
                <Route path="/men" element={<Shop categoryOverride="adults" />} />
                <Route path="/adults" element={<Shop categoryOverride="adults" />} />
                <Route path="/twinning" element={<Shop twinning />} />
                <Route path="/motif/:motif" element={<Motif />} />
                <Route path="/motif-preview/:motif" element={<MotifPreview />} />
                <Route path="/motif-preview" element={<MotifPreview />} />
                <Route path="/home-preview" element={<HomePreview />} />
                <Route path="/home-hero-preview" element={<HomeHeroPreview />} />
                <Route path="/home-yesterday-preview" element={<HomeYesterdayPreview />} />
                <Route path="/home-cinematic-preview" element={<HomeCinematicPreview />} />
                <Route path="/home-editorial-preview" element={<HomeEditorialPreview />} />
                <Route path="/product/:slug" element={<Product />} />
                <Route path="/product/lovely-lotus" element={<Product legacySlug="lovely-lotus-pink" />} />
                <Route path="/product/tiny-bud" element={<Product legacySlug="dearmy-hearts" />} />
                <Route path="/product/dreamy-hearts" element={<Product legacySlug="tiny-buds" />} />
                <Route path="/product/dragon-fly-lilac" element={<Product legacySlug="dragonfly-lilac" />} />
                <Route path="/product/dragon-fly-pink" element={<Product legacySlug="dragonfly-pink" />} />
                <Route path="/product/cracy-car-lilac" element={<Product legacySlug="crazy-car-lilac" />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/order/:orderNo" element={<OrderConfirmation />} />
                <Route path="/our-story" element={<About />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact-us" element={<Contact />} />
                <Route path="/the-craft" element={<TheCraft />} />
                <Route path="/journal" element={<Journal />} />
                <Route path="/journal/:slug" element={<JournalArticle />} />
                <Route path="/frequently-asked-questions" element={<Simple title="Frequently Asked Questions" kind="faq" />} />
                <Route path="/terms-conditions" element={<Simple title="Terms & Conditions" kind="terms" />} />
                <Route path="/return" element={<Simple title="Returns & Exchanges" kind="returns" />} />
                <Route path="/privacy-policy" element={<Simple title="Privacy Policy" kind="privacy" />} />
                <Route path="/tracking-order" element={<Simple title="Track your order" kind="tracking" />} />
                <Route path="/wishlist" element={<Simple title="Wishlist" kind="wishlist" />} />
                <Route path="/my-account" element={<Simple title="My account" kind="account" />} />
                <Route path="/preview/collection" element={<CollectionPreview />} />
                <Route path="/preview/shop" element={<ShopPreview />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/admin/product/:slug" element={<AdminProductEdit />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </SiteChrome>
            <Toaster position="top-center" toastOptions={{ style: { background: "var(--ground)", color: "var(--ink)", border: "1px solid var(--stone)", borderRadius: 0 } }} />
          </CartProvider>
        </SiteProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
